import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRequiredProperty } from 'src/app/hooks/context/context.hook'
import RequiredProperty from '../../../components/required-property/required-property'
import ListLayout from '../../../layout/list-layout/list-layout'
import { ReservationDetailDrawer } from '../reservation-detail/reservation-detail-wrapper'
import ReservationList from './reservation-list'
import ReservationNewDrawer from '../reservation-insert/reservation-new.drawer'
import ReservationUpsertDrawer from '../reservation-group-upsert/reservation-group-upsert-drawer'
import ReservationTimeNewDrawer from '../reservation-time-insert/reservation-time-new-drawer'
import { useParams } from 'react-router-dom'
import { HtmlElementId } from 'src/app/layout/html-element-id.type'

export enum ReservationsListParams {
  LIST = 'LIST',
  FROM_QUOTATION = 'FROM_QUOTATION',
}

function ReservationListPage() {
  const params = useParams()
  const { t } = useTranslation()
  const { id: propertyId } = useRequiredProperty()
  const [selectedReservationId, setSelectedReservationId] = useState<string>()
  const [openNewReservation, setOpenNewReservation] = useState<boolean>(false)
  const [openNewGroupReservation, setOpenNewGroupReservation] = useState<boolean>(false)
  const [openNewTimeReservation, setOpenNewTimeReservation] = useState<boolean>(false)

  useEffect(() => {
    if (params.enumParam && params.enumParam === ReservationsListParams.FROM_QUOTATION) {
      setOpenNewReservation(true)
    }
  }, [params.enumParam])

  return (
    <>
      <ListLayout title={t('pms.booking.reservation.list_title')} id={HtmlElementId.TSH_PAGE_RESERVATIONS_LIST}>
        <ReservationList
          propertyId={propertyId}
          onEditClick={(reservationId) => setSelectedReservationId(reservationId)}
          onAddSingleReservationClick={() => setOpenNewReservation(true)}
          onAddGroupReservationClick={() => setOpenNewGroupReservation(true)}
          onAddTimeReservationClick={() => setOpenNewTimeReservation(true)}
        />
      </ListLayout>

      <ReservationDetailDrawer //
        propertyId={propertyId}
        reservationId={selectedReservationId}
        open={selectedReservationId ? true : false}
        onClose={() => setSelectedReservationId(undefined)}
      />

      {openNewReservation && (
        <ReservationNewDrawer
          open={openNewReservation}
          onCancel={() => setOpenNewReservation(false)}
          onConfirm={() => setOpenNewReservation(false)}
          propertyId={propertyId}
          onGoToCreateGroupReservation={() => {
            setOpenNewReservation(false)
            setOpenNewGroupReservation(true)
          }}
          onSubmitAndOpenReservation={(reservationId) => {
            setSelectedReservationId(reservationId)
          }}
        />
      )}

      {openNewGroupReservation && (
        <ReservationUpsertDrawer
          open={openNewGroupReservation}
          onCancel={() => setOpenNewGroupReservation(false)}
          onConfirm={() => setOpenNewGroupReservation(false)}
          propertyId={propertyId}
          onGoToCreateSingleReservation={() => {
            setOpenNewReservation(true)
            setOpenNewGroupReservation(false)
          }}
          onSubmitAndOpenReservation={(reservationId) => {
            setSelectedReservationId(reservationId)
          }}
        />
      )}

      {openNewTimeReservation && (
        <ReservationTimeNewDrawer
          propertyId={propertyId}
          open={openNewTimeReservation}
          onCancel={() => setOpenNewTimeReservation(false)}
          onConfirm={() => setOpenNewTimeReservation(false)}
          // onGoToCreateSingleReservation={() => {
          //   setOpenNewReservation(true)
          //   setOpenNewGroupReservation(false)
          // }}
          onSubmitAndOpenReservation={(reservationId) => {
            setSelectedReservationId(reservationId)
          }}
        />
      )}
    </>
  )
}

export default () => (
  <RequiredProperty>
    <ReservationListPage />
  </RequiredProperty>
)
